/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import "../../../scss/custom.scss";
import {
  DataTableSkeleton,
  Dropdown,
  Button,
  TableToolbar,
  Loading
} from "carbon-components-react";
import DrillReportMultiSelectDataTable from "./DrillReportMultiSelectDataTable";
import { api, drill } from "../../../helpers/api/api";
import { showNotification } from "../../../helpers/notification/BaseNotification";
import { AppContext } from "../../../helpers/context/AppContext";
import { IsEnabled } from "../../../helpers/authorization/Policies";
import PageBreadCrumb from "../../../helpers/PageBreadCrumb";
import { InspectionMonthHeader } from "../../inspection/common/InspectionMonthHeader";
import Add16 from "@carbon/icons-react/lib/add/16";
import Data16 from "@carbon/icons-react/lib/data--1/16";
import { IsInRole } from "../../../helpers/authorization/Policies";
import { Calendar16 } from "@carbon/icons-react";
import DrillReportFilterModal from "./DrillReportFilterModal";
import DrillRepository from '../../../helpers/api/DrillRepository';
import moment from "moment";
import {
  getError,
  entitiesLabels,
  apioperation,
  getSuccess,
} from "../../../helpers/Constants";
import { DrillReportInformation } from "./reportDetails/DrillReportInformation";
import { CalendarSkeleton } from '../../inspection/inspectionReport/common/CalendarSkeleton';
import { EDLegendTable } from "../EDLegendTable";
import { LegendType} from '../common/EDLegendType';


export default class DrillReportList extends Component {
  searchProp = () => ({
    entityInfo: {
      id: null,
      idDrillPlan: this.props.match.params?.id,

      idEmergencyLevel: null,
      idStatus: null,

      drillEmergencyLevel: null,
      status: null,
      code: null,
      dateOfOccurence: null,
      dataApproverEmail: null,
      compilerEmail: null,
      divisionManager: null,
    },
    calendarInfo: {
      plannedWeeks: [],
      referenceYear: new Date().getFullYear(),
      monthNumbers: [],
    },
  });

  constructor(props) {
    super(props);
    this.year = new Date().getFullYear();
    this.showAddDrillReport = this.showAddDrillReport.bind(this);
    this.showEditDrillReport = this.showEditDrillReport.bind(this);
    this.buildFilter = this.buildFilter.bind(this);
    this.newDrillReportAdded = this.newDrillReportAdded.bind(this);
    this.eDrillUpdated = this.eDrillUpdated.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.toogleCalendar = this.toogleCalendar.bind(this);
    this.toogleFilterModal = this.toogleFilterModal.bind(this);
    this.handleChangePaging = this.handleChangePaging.bind(this);
    this.filterByWeek = this.filterByWeek.bind(this);
    this.filterByMonths = this.filterByMonths.bind(this);
    

    this.state = {
      monthsSelected:[],
      idDrillReport: null,
      eDrillToModify: null,
      items: [],
      originalItems: [],
      modalDrillReportVisible: false,
      calendar: [],
      isOpenCalendar: true,
      isBack: this.props.history.action === 'POP' || this.props.location.search === '?isBack' ? true : false,

      //filter
      isOpenSearchForm: false,
      years: [],
      searchModel: {
        ...this.searchProp(),
        entityInfo: {
          ...this.searchProp.entityInfo,
          idDrillPlan: this.props.match.params?.id ,
        },
        needToChange: true,
      },

      //pagination
      paginationInfo: {
        currentPage: 1,
        pageSize: 10,
        rowCount: 0,
      },

      // loading
      isLoadingTable: false,
      isLoadingCalendar: false,
      tabsLoading: true,
    };

    this.year = new Date().getFullYear();
    this.month = new Date().getMonth();
    this.weeks = moment().weeks();
  }

  //************* API ************* START
  getItems = async () => {
    let items = [];
    try {
      this.getCalendar();
      //items = (await api.getAll(`/drillReport`)).data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, "loading Drill Report", "ERROR"));
    }
    return items;
  };
  //************* API ************* END

  //************* HOOKS ************* START
  async componentDidMount() {
    this.setState({ loading: true, tabsLoading: true });
    const items = await this.getItems();
    this.setState({
      items,
      originalItems: items,
      loading: false,
      tabsLoading: false,
    });
  }
  //************* HOOKS ************* END

  onDelete = async (items) => {
    this.setState(
      (prevState) => ({
        originalItems: prevState.originalItems.filter((item) => {
          const deletedId = items.map((filter) => filter.id);
          const itemId = item.id;
          return !deletedId.includes(itemId);
        }),
      }),
      () => {
        this.setState((state) => ({
          items: this.buildFilter(state.originalItems, null, null),
        }));
      }
    );
  };

  buildFilter = (items, filters) => {
    let filteredItems =
      filters !== null
        ? items.filter((item) => this.checkItem(item, filters))
        : items;
    this.setState(() => ({
      items: filteredItems,
    }));
    return filteredItems;
  };

  checkItem = (item, filters) => {
    for (var prop in filters) {
      if (Object.prototype.hasOwnProperty.call(filters, prop)) {
        if (
          typeof filters[prop] !== "object" &&
          filters[prop] != "" &&
          filters[prop] != null &&
          filters[prop] != item[prop]
        )
          return false;

        if (
          Array.isArray(filters[prop]) &&
          JSON.stringify(filters[prop]) != JSON.stringify(item[prop])
        )
          return false;
        else if (filters[prop] != null && item[prop].name != filters[prop].name)
          return false;
      }
    }
    return true;
  };

  applyFilters = (filters, apply) => {
    this.setState((state) => ({
      items: this.buildFilter(state.originalItems, apply ? filters : null),
    }));
  };

  showAddDrillReport() {
    this.setState((oldState) => ({
      modalDrillReportVisible: !oldState.modalDrillReportVisible,
      eDrillToModify: null,
    }));
  }

  showEditDrillReport(row) {
    this.setState((oldState) => ({
      modalDrillReportVisible: !oldState.modalDrillReportVisible,
      eDrillToModify: oldState.items.find((item) => item.id === row.id),
    }));
  }

  newDrillReportAdded(item) {
    this.setState(
      (prevState) => ({ originalItems: prevState.originalItems.concat(item) }),
      () => {
        this.setState((state) => ({
          items: this.buildFilter(state.originalItems, null, null),
          modalDrillReportVisible: !state.modalDrillReportVisible,
          searchModel: {
            ...this.state.searchModel,
            needToChange: true,
          },
        }));
      }
    );

    this.getCalendar();
  }

  async refreshData() {
    this.setState({
      loading: true,
      searchModel: {
        ...this.state.searchModel,
        needToChange: true,
      },
    });
    this.getCalendar();
  }

  eDrillUpdated(eDrillPlan) {
    const itemList = this.state.originalItems.filter(
      (item) => item.id !== eDrillPlan.id
    );
    itemList.unshift(eDrillPlan);

    this.setState((state) => ({
      originalItems: itemList,
      items: this.buildFilter(itemList, null, null),
      modalDrillReportVisible: !state.modalDrillReportVisible,
      searchModel: {
        ...this.state.searchModel,
        needToChange: true,
      },
    }));

    this.getCalendar();
  }

  //  *************** FILTERS *************** START

  toogleFilterModal(e) {
   
    e.preventDefault();
    this.setState((oldState) => ({
      isOpenSearchForm: !oldState.isOpenSearchForm,
    }));
  }

  searchDrills = (e, currentSearchModal) => {
   
    e.preventDefault();
    const infoFilter = currentSearchModal;
    console.log(infoFilter);
    this.toogleFilterModal(e);
    this.setState(
      {
        isBack : currentSearchModal.isBack,
        searchModel: {
          ...this.state.searchModel,
          entityInfo: { ...currentSearchModal,
            idDrillPlan:  this.props.match.params?.id,
            idEmergencyLevel: currentSearchModal.idEmergencyLevel,
            idStatus: currentSearchModal.idStatus,
            drillEmergencyLevel: currentSearchModal.drillEmergencyLevel,
            status: currentSearchModal.status,
            code: currentSearchModal.code,
            dateOfOccurence: currentSearchModal.dateOfOccurence,
            dataApproverEmail : currentSearchModal.dataApproverEmail,
            compilerEmail : currentSearchModal.compilerEmail,
            divisionManager : currentSearchModal.divisionManagerEmail,
            },
            calendarInfo : {
            plannedWeeks: [],
            monthNumbers: [],
            referenceYear : this.state.searchModel.calendarInfo?.referenceYear,
            },
          needToChange: true,
        },
        calendar : [],
      },
      () => {
        this.getCalendar({ page: 1 });
      }
    );
  };

  cancelFilters = (e, currentSearchModal) => {
    e.preventDefault();
    this.toogleFilterModal(e);
    this.setState(
      {
        isBack : currentSearchModal.isBack,
        searchModel: {
          ...this.searchProp(),
          needToChange: true,
        },
        calendar : [],
      },
      () => {
        this.getCalendar({ page: 1 });
      }
    );
  };

  closeFilters = (e) => {
    this.toogleFilterModal(e);
  };

  handleChangePaging = (event) => {
    this.setState({
      paginationInfo: {
        currentPage: event.currentPage,
        pageSize: event.pageSize,
        page: event.page,
        rowCount: event.rowCount,
      },
      searchModel: {
        ...this.state.searchModel,
        needToChange: false
      },
    });
    this.getCalendar(event);
  };
  //  *************** FILTERS *************** END

  //  *************** CALENDAR *************** START

  toogleCalendar() {
    this.setState((oldState) => ({ isOpenCalendar: !oldState.isOpenCalendar }));
  }

  getCalendar = async(param) => {
    var data = null;
    var toFilter = null;
    this.setState({
      isLoadingTable: true,
    });
    if (!this.state.isBack) {
       data = {
        params: {
          ...this.state.searchModel?.calendarInfo,
          ...this.state.searchModel?.entityInfo,
          idDrillPlan: this.props.match.params?.id,
          page:
            param && param.page
              ? param.page
              : this.state.paginationInfo?.currentPage,
          pageSize:
            param && param.pageSize
              ? param.pageSize
              : this.state.paginationInfo?.pageSize,
          plannedWeeks: this.state.searchModel.calendarInfo?.plannedWeeks?.join(
            ","
          ),
          monthNumbers: this.state.searchModel.calendarInfo?.monthNumbers?.join(
            ","
          ),
          needToChange: this.state.searchModel.needToChange,
        },
      };
    } else {
      let filter = await DrillRepository.getReportBackPaged();
       data = {
        params: {
          ...filter.searchModel?.calendarInfo,
          ...filter.searchModel?.entityInfo,
          idDrillPlan: this.props.match.params?.id,
          page:
            param && param.page
              ? param.page
              : this.state.paginationInfo?.currentPage,
          pageSize:
            param && param.pageSize
              ? param.pageSize
              : this.state.paginationInfo?.pageSize,
          plannedWeeks: filter.searchModel.calendarInfo?.plannedWeeks?.join(
            ","
          ),
          monthNumbers: filter.searchModel.calendarInfo?.monthNumbers?.join(
            ","
          ),
          needToChange: filter.calendar.length > 0 ? false : true,
        },
      };
      this.setState({
        searchModel: filter?.searchModel,
        calendar: filter.calendar,
        needToChange: filter.calendar.length > 0 ? false : true,
        isBack : false,
      });
    }
    this.getDrillReportFilter(data);
}

getDrillReportFilter(filter){
    drill
      .getReportCalendar(filter)
      .then((response) => {
        var data = response.data;

        var filterToCache ={
          searchModel: {
            calendarInfo : this.state.searchModel?.calendarInfo,
            entityInfo : this.state.searchModel?.entityInfo,
            needToChange: false,
          },
          calendar : this.state.calendar
        }
        DrillRepository.updateReportDrillFilter(filterToCache);
        this.setState({
          searchModel: { ...this.state.searchModel, needToChange: false },
          paginationInfo: {
            currentPage: data.currentPage,
            pageSize: data.pageSize,
            page: data.page,
            rowCount: data.rowCount,
          },
          calendar: data.events?.fourMonthsList || this.state.calendar,
          items: data.itemList || this.state.items,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DrillReport, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingTable: false,
          isLoadingCalendar: false,
        });
      });
  }

  filterByWeek = (weekNumber) => {
    this.setState({isBack : false});
    let year;
    try {
      year = this.state.searchModel.calendarInfo?.referenceYear;
      let statusCopy = Object.assign({}, this.state);
      statusCopy.searchModel.calendarInfo.referenceYear = year;
      statusCopy.isBack = false;

      const index = statusCopy.searchModel.calendarInfo.plannedWeeks.indexOf(
        weekNumber
      );
      if (index > -1)
        statusCopy.searchModel.calendarInfo.plannedWeeks.splice(index, 1);
      else statusCopy.searchModel.calendarInfo.plannedWeeks.push(weekNumber);

      statusCopy.searchModel.needToChange = false;
      statusCopy.isBack = false;
      statusCopy.isfilterByWeek = true;
      this.setState(statusCopy);
      this.getCalendar({ page: 1 });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.DrillReport, apioperation.GET)
      );
    } finally {
    }
  };
  filterByMonths = (month) => {
    let year;
    this.setState({isBack : false});
    try {
      year = this.state.searchModel.calendarInfo.referenceYear;
      let statusCopy = Object.assign({}, this.state);
      statusCopy.searchModel.calendarInfo.referenceYear = year;
      const index = statusCopy.searchModel.calendarInfo.monthNumbers.indexOf(
        month.monthsNumber
      );
      if (index > -1)
        statusCopy.searchModel.calendarInfo.monthNumbers.splice(index, 1);
      else
        statusCopy.searchModel.calendarInfo.monthNumbers.push(
          month.monthsNumber
        );

      statusCopy.searchModel.needToChange = false;
      statusCopy.isBack = false;
      statusCopy.isfilterByWeek = true;
      this.setState(statusCopy);
      this.getCalendar({ page: 1 });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.DrillReport, apioperation.GET)
      );
    } finally {
    }
  };

  //  *************** CALENDAR *************** END

  render() {
    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;
    return (
      <AppContext.Consumer>
        {({ user }) =>
          IsEnabled(user, "Emergency Drill") ? (
            <>
              <PageBreadCrumb
                linkTo="/drill?isBack"
                linkText="Drill Plan List"
                titleLeft={`Drill Plan ID: ${
                  this.state.items.length > 0
                    ? this.state.items[0].drillPlan?.drillCode
                    : ""
                }`}
                titleCenter="Drill Report List"
                //titleRight={}
              />
              <div className="mainContainer">
                <div className="bx--col detail--information drill">
                  <DrillReportInformation
                    is4ASingleReport={false}
                    tabsLoading={this.state.tabsLoading}
                    drillReport={
                      this.state.items.length === 0 ? null : this.state.items[0]
                    }
                  />
                </div>
                <div className="headerReportContainer">

                  

                  <div>
                      <table className='table-legend-drill'>
                          <EDLegendTable arrLegend={[LegendType.RED_REPORT, LegendType.ORANGE_REPORT, LegendType.GREEN_REPORT]}></EDLegendTable>
                      </table>
                  </div>

                  <div className="header-drill-custom-toolbar">
                    <TableToolbar>
                      <Button
                        onClick={this.toogleCalendar}
                        className="buttonPaddingIcon"
                        renderIcon={Calendar16}
                        iconDescription="Calendar"
                      />
                      <Button
                        onClick={this.toogleFilterModal}
                        className="buttonPaddingIcon"
                        renderIcon={Data16}
                        iconDescription="Filter"
                      />
                    </TableToolbar>
                  </div>
                </div>
                
                {/*CALENDAR*/}
                <div
                  style={{
                    display: this.state.isOpenCalendar ? "block" : "none",
                  }}
                >
                  {this.state.searchModel.needToChange ? (
                 <div className="layout-skeleton-calendar">
                 <Loading withOverlay />
                 <table className="table-layout-custom">
                   <CalendarSkeleton />
                 </table>
               </div>
                  ) : (
                    <table className="table-layout-custom">
                      <InspectionMonthHeader
                        calendar={this.state.calendar}
                        onSelectWeek={this.filterByWeek}
                        onSelectMonth={this.filterByMonths}
                        monthsSelected = {this.state.monthsSelected}
                        isDrill = {true}
                      />
                    </table>
                  )}
                </div>

                <div className="bx--grid content full-width mainContainer ">
                {this.state.isOpenSearchForm ? (
                    <DrillReportFilterModal
                      searchModel={this.state.searchModel.entityInfo}
                      onSearch={this.searchDrills}
                      onCancel={this.cancelFilters}
                      onClose={this.closeFilters}
                      checkBack ={this.state.isBack}
                    />
                  ) : null}
                  {this.state.isLoadingTable ? (
                    <DataTableSkeleton />
                  ) : (
                    <DrillReportMultiSelectDataTable
                      eDrills={this.state.items}
                      onNewDrillReport={this.showAddDrillReport}
                      onEditDrillReport={this.showEditDrillReport}
                      onStatusChanged={this.eDrillUpdated}
                      onRefreshData={this.refreshData}
                      onDelete={this.onDelete}
                      applyFilters={this.applyFilters}
                     // toogleCalendar={this.toogleCalendar}
                      toogleFilterModal={this.toogleFilterModal}
                      handleChangePaging={this.handleChangePaging}
                      paginationInfo={this.state.paginationInfo}
                    />
                  )}
                </div>
              </div>
            </>
          ) : null
        }
      </AppContext.Consumer>
    );
  }
}
